<div class="form__block">
  <div class="subtitle mb-30">
    <h2>{{  field.label}}</h2>
  </div>

  <form [formGroup]="form">
    <ng-container  *ngIf="isAndroidDevice">
      <div class="form__groups">
        <div class="form__group" [ngClass]="{'form__error': isSubmitted() &&(!form.get('nombre')?.value ||!form.get('telefono')?.value ||form.get('telefono')?.hasError('invalid'))}">
          <div class="form__contactRef">
            <div class="form__contactRefItem" [ngClass]="{'complete': form.get('nombre')?.value && form.get('telefono')?.value}" (click)="pickContacts()">
              <div class="icon">
                <i class="iconEmpty">
                  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle class="fill" cx="17.4999" cy="17.4999" r="15.1667" fill="#D9D9D9"/>
                    <circle class="stroke" cx="17.5" cy="17.5" r="17" stroke="#969696"/>
                    <path class="fillWhite" d="M13.9996 24.7589V25.6663H15.9441V24.7589H13.9996ZM23.7219 24.7589V25.6663H25.6663V24.7589H23.7219ZM15.9441 24.7589V23.8515H13.9996V24.7589H15.9441ZM23.7219 23.8515V24.7589H25.6663V23.8515H23.7219ZM19.833 20.2219C20.8644 20.2219 21.8535 20.6043 22.5828 21.285C23.3121 21.9657 23.7219 22.8889 23.7219 23.8515H25.6663C25.6663 22.4076 25.0517 21.0228 23.9578 20.0017C22.8638 18.9807 21.3801 18.4071 19.833 18.4071V20.2219ZM15.9441 23.8515C15.9441 22.8889 16.3538 21.9657 17.0831 21.285C17.8124 20.6043 18.8016 20.2219 19.833 20.2219V18.4071C18.2859 18.4071 16.8021 18.9807 15.7082 20.0017C14.6142 21.0228 13.9996 22.4076 13.9996 23.8515H15.9441ZM19.833 9.33301C18.8016 9.33301 17.8124 9.71541 17.0831 10.3961C16.3538 11.0768 15.9441 12 15.9441 12.9626H17.8885C17.8885 12.4813 18.0934 12.0197 18.458 11.6794C18.8227 11.339 19.3173 11.1478 19.833 11.1478V9.33301ZM23.7219 12.9626C23.7219 12 23.3121 11.0768 22.5828 10.3961C21.8535 9.71541 20.8644 9.33301 19.833 9.33301V11.1478C20.3487 11.1478 20.8432 11.339 21.2079 11.6794C21.5725 12.0197 21.7774 12.4813 21.7774 12.9626H23.7219ZM19.833 16.5923C20.8644 16.5923 21.8535 16.2099 22.5828 15.5292C23.3121 14.8485 23.7219 13.9253 23.7219 12.9626H21.7774C21.7774 13.444 21.5725 13.9056 21.2079 14.2459C20.8432 14.5862 20.3487 14.7775 19.833 14.7775V16.5923ZM19.833 14.7775C19.3173 14.7775 18.8227 14.5862 18.458 14.2459C18.0934 13.9056 17.8885 13.444 17.8885 12.9626H15.9441C15.9441 13.9253 16.3538 14.8485 17.0831 15.5292C17.8124 16.2099 18.8016 16.5923 19.833 16.5923V14.7775Z" fill="#969696"/>
                    <path class="strokeWhite" d="M11.667 19.8335V12.8335M8.16699 16.3335H15.167" stroke="#969696" stroke-width="1.5"/>
                  </svg>
                </i>
                <i class="iconComplete">
                  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle class="svgPath--primary" cx="17.4999" cy="17.4999" r="15.1667" fill="#000"/>
                    <circle class="svgStroke--primary" cx="17.5" cy="17.5" r="17" stroke="#000"/>
                    <path d="M12 24.9259V25.8333H13.9444V24.9259H12ZM21.7222 24.9259V25.8333H23.6667V24.9259H21.7222ZM13.9444 24.9259V24.0185H12V24.9259H13.9444ZM21.7222 24.0185V24.9259H23.6667V24.0185H21.7222ZM17.8333 20.3889C18.8647 20.3889 19.8539 20.7713 20.5832 21.452C21.3125 22.1327 21.7222 23.0559 21.7222 24.0185H23.6667C23.6667 22.5746 23.0521 21.1897 21.9581 20.1687C20.8642 19.1477 19.3804 18.5741 17.8333 18.5741V20.3889ZM13.9444 24.0185C13.9444 23.0559 14.3542 22.1327 15.0835 21.452C15.8128 20.7713 16.8019 20.3889 17.8333 20.3889V18.5741C16.2862 18.5741 14.8025 19.1477 13.7085 20.1687C12.6146 21.1897 12 22.5746 12 24.0185H13.9444ZM17.8333 9.5C16.8019 9.5 15.8128 9.88241 15.0835 10.5631C14.3542 11.2438 13.9444 12.167 13.9444 13.1296H15.8889C15.8889 12.6483 16.0937 12.1867 16.4584 11.8464C16.8231 11.506 17.3176 11.3148 17.8333 11.3148V9.5ZM21.7222 13.1296C21.7222 12.167 21.3125 11.2438 20.5832 10.5631C19.8539 9.88241 18.8647 9.5 17.8333 9.5V11.3148C18.349 11.3148 18.8436 11.506 19.2083 11.8464C19.5729 12.1867 19.7778 12.6483 19.7778 13.1296H21.7222ZM17.8333 16.7593C18.8647 16.7593 19.8539 16.3769 20.5832 15.6962C21.3125 15.0155 21.7222 14.0923 21.7222 13.1296H19.7778C19.7778 13.6109 19.5729 14.0726 19.2083 14.4129C18.8436 14.7532 18.349 14.9444 17.8333 14.9444V16.7593ZM17.8333 14.9444C17.3176 14.9444 16.8231 14.7532 16.4584 14.4129C16.0937 14.0726 15.8889 13.6109 15.8889 13.1296H13.9444C13.9444 14.0923 14.3542 15.0155 15.0835 15.6962C15.8128 16.3769 16.8019 16.7593 17.8333 16.7593V14.9444Z" fill="white"/>
                  </svg>
                </i>
              </div>
              <div class="text">
                <div class="textEmpty">
                  <h3>Agregar un contacto</h3>
                </div>

                <div class="textComplete">
                  <h3>{{ form.get('nombre')?.value }}</h3>
                  <p>{{ form.get('telefono')?.value }}</p>
                </div>
              </div>
              <div class="action" (click)="removeContacts()">
                <i>
                  <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="svgPath--primary" d="M4.6875 0V0.952381H0V2.85714H0.9375V15.2381C0.9375 15.7433 1.13504 16.2278 1.48667 16.585C1.83831 16.9422 2.31522 17.1429 2.8125 17.1429H12.1875C12.6848 17.1429 13.1617 16.9422 13.5133 16.585C13.865 16.2278 14.0625 15.7433 14.0625 15.2381V2.85714H15V0.952381H10.3125V0H4.6875ZM2.8125 2.85714H12.1875V15.2381H2.8125V2.85714ZM4.6875 4.7619V13.3333H6.5625V4.7619H4.6875ZM8.4375 4.7619V13.3333H10.3125V4.7619H8.4375Z" fill="#000"/>
                  </svg>
                </i>
              </div>
            </div>

            <span class="form__msgError" *ngIf="isSubmitted() && !form.get('nombre')?.value && !form.get('telefono')?.value">
                      <small class="p-error">Este campo es requerido</small>
                    </span>

            <span class="form__msgError" *ngIf="isSubmitted() && !form.get('nombre')?.value && !form.get('telefono')?.value">
                      <small class="p-error">Este campo es requerido</small>
                    </span>

            <span class="form__msgError" *ngIf="isSubmitted() && (!form.get('nombre')?.value ||!form.get('telefono')?.value ||form.get('telefono')?.hasError('invalid'))">
              <small class="p-error">Teléfono invalido</small>
            </span>

            <span class="form__msgError"
                  *ngIf="isSubmitted() && (!form.get('nombre')?.value ||!form.get('telefono')?.value ||form.get('telefono')?.hasError('duplicate'))">
                  <small class="p-error">Teléfono ya registrado*</small>
            </span>

          </div>
        </div>
      </div>


    </ng-container>

    <ng-container *ngIf="!isAndroidDevice">
      <div class="form__group">
        <div class="form__group" [ngClass]="{'form__error': isSubmitted() && f['nombre'].errors}">
          <div class="p-float-label">
            <input pInputText  type="text" formControlName="nombre" placeholder="ingresar nombre" (blur)="onGenerateDataToSave()"/>
            <label>Nombres y apellido *</label>
          </div>

          <span class="form__msgError" *ngIf="isSubmitted() && f['nombre'].errors">
                    <small class="p-error" *ngIf="f['nombre'].hasError('required')">Requerido</small>
                  </span>
        </div>

        <div class="form__group" [ngClass]="{'form__error':isSubmitted() && f['telefono'].errors}">
          <div class="p-float-label">
            <p-inputMask  placeholder="Telefono" formControlName="telefono" [mask]="country.phoneCountryMask" (onBlur)="onGenerateDataToSave()"></p-inputMask>
            <label>Teléfono *</label>
          </div>

          <span class="form__msgError" *ngIf="isSubmitted() && f['telefono'].errors">
                    <small class="p-error" *ngIf="f['telefono'].hasError('required')">Requerido</small>
            <small class="p-error" *ngIf="f['telefono'].hasError('invalid')">{{ 'Teléfono' | invalid }}</small>
             <small class="p-error" *ngIf="f['telefono'].hasError('duplicate')">Teléfono ya registrado*</small>
                  </span>

          <span class="form__msgValidate" *ngIf="f[field.key] && f[field.key].pending">
            <small class="p-validate">
              <i class="pi pi-spin pi-spinner"></i>
             <span>Validando télefono...</span>
            </small>
          </span>

        </div>
      </div>
    </ng-container>

    <div class="generalButton mt-30" *ngIf="isAndroidDevice">
      <button pButton pRipple label="Ingresar contacto manualmente" icon="pi pi-plus" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded n-background min-pad" (click)="addManualPersonalReference()"></button>
    </div>
  </form>
</div>





